import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Card,
  Grid,
  InputLabel,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  CircularProgress,
  Typography,
  Box,
  Select,
  OutlinedInput,
  MenuItem,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import {
  mobileAbhaSearchThunk,
  mobileOtpThunk,
  verifyOtpThunk,
} from "./reducer/thunk.js";
import Methods from "../../utility/Methods.js";
import Colors from "../../utility/Colors.js";
import OtpVerification from "../../components/otpVerification/otpVerification.js";
import { useNavigate } from "react-router-dom";
import { getSession, setLoginDetails } from "../../utility/SessionManager.js";
import constants from "../../common/constants.js";
import BackdropComponent from "../../components/backdrop/index.tsx";
import {
  resetMobileAbhaSearch,
  resetMobileOtp,
  resetVerifyOtp,
} from "./reducer/slice.js";
import {
  resetMobileVerifyOtpRequest,
  resetMobileVerifyOtp,
} from "../Register/reducer/abhaAadhar/slice.js";

const MobileLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMounted = React.useRef(false);

  const [showOTP, setShowOTP] = useState(false);
  const [showAbhaProfile, setShowAbhaProfile] = useState(false);
  const [abhaCardArray, setAbhaCardArray] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [authType, setAuthType] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [OTP, setOTP] = useState("");
  const [txnId, setTxnId] = useState("");
  const [message, setMessage] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const mobileOtp = useSelector((state) => state.login.mobileOtp);
  const {
    status: mobileOtpStatus,
    data: mobileOtpData,
    error: mobileOtpError,
  } = mobileOtp;
  const mobileAbhaSearch = useSelector((state) => state.login.mobileAbhaSearch);
  const {
    status: mobileAbhaSearchStatus,
    data: mobileAbhaSearchData,
    error: mobileAbhaSearchError,
  } = mobileAbhaSearch;
  const verifyOtp = useSelector((state) => state.login.verifyOtp);
  const {
    status: verifyOtpStatus,
    data: verifyOtpData,
    error: verifyOtpError,
  } = verifyOtp;
  const { loading } = useSelector((state) => state.auth);

  useEffect(() => {
    // Only trigger if component has mounted (not on initial mount with stale state)
    if (isMounted.current && mobileOtpStatus === "succeeded") {
      console.log("enc res", mobileOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(mobileOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(mobileOtpData?.data));
      console.log("test ", decData.response);
      let finalData = decData.response;
      setTxnId(finalData?.txnId);
      setMessage(finalData?.message);
      setShowAbhaProfile(false);
      setShowOTP(true);
      handleShowSnackbar("success", "OTP sent successfully!");
    } else if (isMounted.current && mobileOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(mobileOtpError));
      console.log("sendOTP data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [mobileOtpStatus]);

  useEffect(() => {
    if (mobileAbhaSearchStatus === "succeeded") {
      console.log("enc res", mobileAbhaSearchData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(mobileAbhaSearchData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(mobileAbhaSearchData?.data));
      console.log("mobileAbhaSearchData ", decData.response);
      let finalData = decData.response;
      setTxnId(finalData?.[0]?.txnId);
      setMessage(finalData?.message);
      setShowAbhaProfile(true);
      setAbhaCardArray(finalData?.[0]?.ABHA);
      setSelectedItem(finalData?.[0]?.ABHA?.[0]);
      handleShowSnackbar("success", "Abha Search completed!");
    } else if (mobileAbhaSearchStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(mobileAbhaSearchError));
      console.log("verifyAbhaSearch data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [mobileAbhaSearchStatus]);

  useEffect(() => {
    // Only trigger if component has mounted (not on initial mount with stale state)
    if (isMounted.current && verifyOtpStatus === "succeeded") {
      console.log("enc res", verifyOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(verifyOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(verifyOtpData?.data));
      console.log("verifyOtp data", decData.response);
      let finalData = decData.response;
      if (finalData?.authResult === "failed") {
        handleShowSnackbar("error", finalData?.message);
      } else if (finalData?.authResult === "success") {
        setLoginDetails(finalData);
        navigate(constants.PATH_DASHBOARD);
        navigate("/dashboard");
        handleShowSnackbar("success", "OTP verified successfully!");
      }
    } else if (isMounted.current && verifyOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(verifyOtpError));
      // console.log("verifyOtp data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [verifyOtpStatus]);

  useEffect(() => {
    if (getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)) {
      navigate(constants.PATH_DASHBOARD);
    }
  }, [navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Reset all Redux state on mount to prevent stale state from showing
    dispatch(resetVerifyOtp());
    dispatch(resetMobileOtp());
    dispatch(resetMobileAbhaSearch());
    // Reset mobile verification state from CreateABHA flow
    dispatch(resetMobileVerifyOtpRequest());
    dispatch(resetMobileVerifyOtp());
    // Mark component as mounted after reset
    isMounted.current = true;
  }, []);

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity,
      message,
    });
  };

  const handleSnackClose = () => {
    setSnackbarOpen({
      open: false,
      severity: "",
      message: "",
    });
  };

  const validationSchema = Yup.object({
    mobileNumber: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
      .required("Mobile number is required"),
  });

  const handleSubmitData = async (data) => {
    setMobileNumber(data?.mobileNumber);
    const reqObj = {
      scope: "search-abha",
      mobile: data?.mobileNumber || "",
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log(
      "decrypted object mobile login",
      Methods.decryptObject(finalReqObj)
    );
    dispatch(mobileAbhaSearchThunk(finalReqObj));
    // const reqObj = {
    //   loginId: data?.mobileNumber || "",
    //   loginHint: "mobile",
    //   txnId: "",
    // };
    // let finalReqObj = Methods.encryptObject(reqObj);
    // // console.log(
    // //   "decrypted object mobile login",
    // //   Methods.decryptObject(finalReqObj)
    // // );

    // dispatch(mobileOtpThunk(finalReqObj));
  };

  const handleSendOtp = () => {
    console.log("authType", authType, "selectedItem", selectedItem);
    const reqObj = {
      loginId: selectedItem?.index,
      loginHint: "index",
      scope: authType,
      // scope: "aadhaar-verify",
      txnId: txnId,
    };

    let finalReqObj = Methods.encryptObject(reqObj);
    console.log(
      "decrypted object mobile login",
      Methods.decryptObject(finalReqObj)
    );
    const headers = {
      scope: "search-abha",
    };
    dispatch(mobileOtpThunk({ ...finalReqObj, headers }));
  };

  const handleSelect = (index) => {
    setSelectedItem(index);
  };

  const handleVerifyOtp = (otp) => {
    setOTP(otp);
    let reqObj = {
      txnId: txnId,
      otp: otp,
      scope: authType,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log(
      "decrypted object verify otp",
      Methods.decryptObject(finalReqObj)
    );
    dispatch(verifyOtpThunk(finalReqObj));
  };

  const handleResendOtp = () => {
    const reqObj = {
      loginId: mobileNumber,
      loginHint: "mobile",
      txnId: txnId,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    dispatch(mobileOtpThunk(finalReqObj));
  };

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "100%",
          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        {mobileOtpStatus === "pending" && <BackdropComponent />}
        {verifyOtpStatus === "pending" && <BackdropComponent />}
        {mobileAbhaSearchStatus === "pending" && <BackdropComponent />}
        {!showOTP && !showAbhaProfile ? (
          <Formik
            initialValues={{ mobileNumber: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleSubmitData(values);
            }}
          >
            {(props) => (
              <Form>
                <Grid container spacing={4} sx={{ p: 1 }}>
                  {[
                    {
                      name: "mobileNumber",
                      label: "Mobile Number",
                      type: "input",
                      required: true,
                    },
                  ].map((field) => (
                    <>
                      {
                        <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <>
                                <InputLabel
                                  htmlFor={field.label}
                                  sx={{ mb: 2 }}
                                >
                                  Enter Mobile Number
                                </InputLabel>
                                <TextField
                                  {...formikField}
                                  variant="outlined"
                                  size="medium"
                                  label={field.label}
                                  required={field?.required}
                                  type={
                                    field.type === "checkbox"
                                      ? "checkbox"
                                      : "text"
                                  }
                                  fullWidth
                                  autoFocus={true}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment
                                        position="start"
                                        sx={{
                                          backgroundColor: "#E9ECF3",
                                          p: 1,
                                          borderRadius: "5px",
                                        }}
                                      >
                                        +91
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton edge="end">
                                          <CheckCircleIcon
                                            color={
                                              meta.value && !meta.error
                                                ? "success"
                                                : "disabled"
                                            }
                                          />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                  error={meta.touched && Boolean(meta.error)}
                                  helperText={meta.touched && meta.error}
                                />
                              </>
                            )}
                          </Field>
                        </Grid>
                      }
                    </>
                  ))}
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{ p: 1 }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    sx={{
                      cursor: "pointer",
                      background:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : "rgb(245, 132, 31)",
                      color:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : Colors.WHITE,
                      px: 6,
                      my: 5,
                      borderRadius: "5px",
                      "&:hover": { opacity: 0.9 },
                    }}
                    type="submit"
                    disabled={!(props.isValid && props.dirty)}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Next"
                    )}
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        ) : showOTP ? (
          <OtpVerification
            onVerify={handleVerifyOtp}
            onResend={handleResendOtp}
            message={message}
          />
        ) : showAbhaProfile ? (
          <>
            We have found the following ABHA number linked to provided mobile
            number. Select the ABHA profile you wish to login.
            {console.log("ABHA card array ", abhaCardArray)}
            {abhaCardArray?.map((key) => {
              return (
                <Grid container spacing={4} sx={{ p: 1, mt: 3, mb: 3 }}>
                  {abhaCardArray.map((item) => (
                    <Grid item size={{ xs: 12, md: 3 }} key={item.index}>
                      <Card
                        onClick={() => handleSelect(item)}
                        sx={{
                          width: "100%",
                          borderRadius: "10px",
                          p: 2,
                          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
                          "&:hover": {
                            boxShadow: "#008080 0px 2px 5px",
                          },
                          border:
                            selectedItem?.index === item.index
                              ? "solid rgb(245, 132, 31) 2px"
                              : "solid #b3b3b3 1px",
                          cursor: "pointer",
                        }}
                      >
                        <Typography variant="h5">{item.name}</Typography>
                        <Typography
                          variant="body1"
                          color={item.kycVerified === "true" ? "green" : "red"}
                        >
                          {item.kycVerified === "true"
                            ? "Verified"
                            : "Not Verified"}
                        </Typography>
                        <Typography variant="body1">
                          ABHA Number: {item.ABHANumber}
                        </Typography>
                        <Typography variant="body1">
                          Gender: {item.gender === "M" ? "Male" : "Female"}
                        </Typography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              );
            })}
            <Grid container>
              <Grid item size={{ xs: 12, md: 6 }}>
                <Typography className="cc_tc_title">
                  Authentication type <span style={{ color: "#f00" }}>*</span>
                </Typography>
                <Box className="nh_search_select">
                  <Select
                    displayEmpty
                    value={authType}
                    input={<OutlinedInput />}
                    inputProps={{ "aria-label": "Without label" }}
                    className="nh_tpa_btn fs-16-600"
                    SelectDisplayProps={{
                      style: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                    }}
                    sx={{
                      marginTop: ".5rem",
                    }}
                    fullWidth
                    onChange={(e) => setAuthType(e.target.value)}
                  >
                    {selectedItem?.authMethods?.includes("AADHAAR_OTP") && (
                      <MenuItem value={"aadhaar-verify"}>Aadhaar OTP</MenuItem>
                    )}
                    {selectedItem?.authMethods?.includes("MOBILE_OTP") && (
                      <MenuItem value={"mobile-verify"}>Mobile OTP</MenuItem>
                    )}
                    {!selectedItem && (
                      <MenuItem value={"mobile-verify"}>Mobile OTP</MenuItem>
                    )}
                  </Select>
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              sx={{ p: 1 }}
              justifyContent="center"
              alignItems="center"
            >
              <Button
                sx={{
                  cursor: "pointer",
                  background: selectedItem ? "rgb(245, 132, 31)" : "#b3b3b3",
                  color: selectedItem ? Colors.WHITE : "#b3b3b3",

                  px: 6,
                  my: 5,
                  borderRadius: "5px",
                  "&:hover": { opacity: 0.9 },
                }}
                onClick={handleSendOtp}
                disabled={!selectedItem || !authType}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Next"
                )}
              </Button>
            </Grid>
          </>
        ) : null}

        <SnackbarComponent
          message={snackbarOpen?.message}
          isOpen={snackbarOpen?.open}
          purpose={snackbarOpen?.severity}
          handleClick={handleSnackClose}
        />
      </Card>
    </div>
  );
};

export default MobileLogin;
